export const VALERA_AUTH = "Basic 3d1e968e72a3d944ac31729832f77c0d93177413df0c534c9f020f8ba7730212";
